<template>
  <div
      v-if="isPermission"
      class="view-settings-aliases"
  >
    <div class="search-card" style="width: 100%">
      <InputSearch
          :value="searchText"
          @input="onSearch"
      />
    </div>
    <modal
        v-show="isModal"
        @close="closeModal"
    >
      <template v-slot:modalBody>
        <form-aliases-add-group
            v-if="isModal"
            @submitForm="onSubmitGroupAdd"
            @cancelForm="closeModal"
        />
      </template>
    </modal>
    <card
        :title="'Тип данных'"
        :isPreloader="attributeIsPreloader"
        :isHover="false"
    >
      <template v-slot:btnContainer>
        <button
            v-if="attributeItemActive !== null"
            class="card__btn_action"
            @click="onClickCreateTask"
        >
          Синхронизировать
        </button>
      </template>
      <template v-slot:cardBody>
        <list-base
            :listItems="attributeList"
            :listItemActive="attributeItemActive"
            @onClickListItem="onClickAttributeListItem"
        />
      </template>
    </card>
    <card
        v-if="attributeItemActiveId == 4 && false"
        :title="'Операторы из каталога'"
        :isPreloader="catalogIsPreloader"
        :isHover="false"
    >
      <template v-slot:cardBody>
        <list-base-with-search
            :listItems="catalogList"
            :listItemActive="catalogItemActive"
            :isIconPrev="true"
            :iconPrevClass="'fa fa-chevron-circle-right'"
            @onClickListItem="onClickCatalogListItem"
            @onClickDeleteCatalog="onClickDeleteCatalog"
        />
      </template>
    </card>
    <card
        v-if="attributeItemActive !== null"
        :title="'Алиасы'"
        :isPreloader="groupIsPreloader"
        :isHover="false"
    >
      <template v-slot:btnContainer>
        <button
            v-if="groupItemActive === null && attributeItemActiveId != 4"
            class="card__btn_action"
            @click="onClickGroupCreate"
        >
          Создать алиас
        </button>
      </template>
      <template v-slot:cardBody>
        <list-group-select
            :listItems="groupList"
            :listItemActive="groupItemActive"
            :isIconPrevMain="catalogItemActive !== null"
            :isIconPrev="true"
            :isIconDelete="false"
            :iconPrevClass="'fa fa-chevron-circle-right'"
            @onClickListItem="onClickGroupListItem"
            @onClickIconPrev="onClickGroupIconPrev"
            @onClickRemoveGroup="onClickGroupRemove"
            @onClickAddToCatalog="onClickAddToCatalog"
        />
      </template>
    </card>
    <card
        v-if="attributeItemActive !== null"
        :title="'Не привязанные значения'"
        :isPreloader="ungroupedIsPreloader"
        :isHover="false"
    >
      <template v-slot:cardBody>
        <list-base
            :listItems="ungroupedList"
            :checked="ungroupedСheckedValues"
            :isCheckbox="groupItemActive === null"
            :isIconPrev="groupItemActive !== null"
            :iconPrevClass="'fa fa-chevron-circle-left'"
            @onChangeCheckbox="onChangeUngroupedCheckbox"
            @onClickIconPrev="onClickUngroupedIconPrev"
        />
      </template>
    </card>
  </div>
  <div v-else>
    У вас нет прав на доступ к настройкам свойств
  </div>
</template>

<script>
/** Честно, хотел как лучше, получилось легаси :( */
import Modal from '../../components/Base/Modal';
import FormAliasesAddGroup from '../../components/Forms/FormAliasesAddGroup';
import {mapMutations, mapState} from 'vuex';
import Card from '../../components/Base/Card';
import ListBase from '../../components/Lists/ListBase';
import ListGroupSelect from '../../components/Lists/ListGroupSelect';
import serviceApi from '../../services/serviceApi';
import schemeApi from '../../schemes/schemeApi';
import serviceAuth from "../../services/serviceAuth";
import InputSearch from "../../components/Base/InputSearch";
import ListBaseWithSearch from "@/components/Lists/ListBaseWithSearch";

let {
  routeAliasesAttributes,
  routeAliasesAttributeGroups,
  routeAliasesUngroupedValues,
  routeAliasesCatalogValues,
  routeAliasesAddGroup,
  routeAliasesRemoveGroup,
  routeCatalogSetValue,
  routeCatalogDeleteValue,
  routeAliasesCreateTask
} = schemeApi;
export default {
  name: 'ViewSettingsAliases',
  components: {
    ListBaseWithSearch,
    Modal,
    FormAliasesAddGroup,
    Card,
    ListBase,
    ListGroupSelect,
    InputSearch
  },
  /**
   * данные компонента
   * @property {array} attributeList - список аттрибутов
   * @property {object} attributeItemActive - активный элемент аттрибутов
   * @property {boolean} attributeIsPreloader - условие показа прелоадера на аттрибутах
   * @property {string} groupRemoveName - название удаляемой группы
   * @property {array} groupListBuffer - буферный массив групп
   * @property {object} groupItemActive - активный элемент списка групп
   * @property {boolean} groupIsPreloader - условие показа прелоадера на группах
   * @property {string} groupNameNew - название новой группы
   * @property {object} groupValueNew - новое значение в группе
   * @property {string} groupValueRemove - удаляемое значение в группе
   * @property {array} ungroupedListBuffer - буферный массив несгруппированных значений
   * @property {array} ungroupedСheckedValues - выбранные значения не сгрупированных аттрибутов
   * @property {boolean} ungroupedIsPreloader - условие показа прелоадера для несгруппированных значений атрибутов
   * @property {boolean} isModal - условие показа модального окна
   * @property {boolean} isPermission - право на показ
   */
  data: () => ({
    attributeList: [],
    attributeItemActive: null,
    attributeItemActiveId: 0,
    attributeIsPreloader: false,
    groupRemoveName: '',
    groupListBuffer: [],
    groupItemActive: null,
    catalogItemActive: null,
    groupIsPreloader: false,
    catalogIsPreloader: false,
    groupNameNew: '',
    groupValueNew: null,
    groupValueRemove: '',
    groupValuesRemove: [],
    catalogListBuffer: [],
    ungroupedListBuffer: [],
    ungroupedСheckedValues: [],
    ungroupedIsPreloader: false,
    isModal: false,
    isPermission: false
  }),
  computed: {
    /**
     * проксируем состояния из стора
     * @property {string} searchText
     */
    ...mapState({
      activeProjectId: state => state.activeProjectId,
      searchText: state => state.searchText
    }),
    /**
     * тело запроса для получения групп
     * @returns {object}
     */
    reqBodyGetGroups() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      let reqBody = {
        attribute_id: attributeActiveId
      };
      return reqBody;
    },
    /**
     * тело запроса для получения несгруппированных значений
     * @returns {object}
     */
    reqBodyGetUngrouped() {
      return {...this.reqBodyGetGroups};
    },
    /**
     * тело запроса для добавления группы
     * @returns {object}
     */
    reqBodyPostAddGroup() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      let reqBody = {
        attribute_id: attributeActiveId,
        group_name: this.groupNameNew,
        values: this.ungroupedСheckedValues
      };
      return reqBody;
    },
    /**
     * тело запроса для добавления значений в группу
     * @returns {object}
     */
    reqBodyPostAddGroupValues() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      let groupActive = this.groupItemActive === null ? null : this.groupItemActive.group;
      let reqBody = {
        attribute_id: attributeActiveId,
        group_name: groupActive,
        values: [this.groupValueNew.name]
      }
      return reqBody;
    },
    /**
     * тело запроса для удаления группы
     * @returns {object}
     */
    reqBodyPostRemoveGroup() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      let reqBody = {
        attribute_id: attributeActiveId,
        group_name: this.groupRemoveName,
      }
      return reqBody;
    },
    /**
     * тело запроса для удаления значений из группы
     * @returns {object}
     */
    reqBodyPostRemoveGroupValues() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      let groupActive = this.groupItemActive === null ? null : this.groupItemActive.group;
      let reqBody = {
        attribute_id: attributeActiveId,
        group_name: groupActive,
        values: [this.groupValueRemove]
      }
      return reqBody;
    },
    /**
     * тело запроса для создания задачи в крон
     * @returns {object}
     */
    reqBodyPostCreateTask() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      let reqBody = {
        attribute_id: attributeActiveId,
      };
      return reqBody;
    },
    /**
     * массив элементов для групп аттрибутов
     * @returns {array}
     */
    groupList() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      if (attributeActiveId === null)
        return [];
      else {
        let groupList = this.groupListBuffer.find((groupItem) => {
          return groupItem.attributeId === attributeActiveId;
        });
        if (typeof groupList === 'undefined')
          return [];
        else
          return groupList.content.filter((groupItem) => {
            const {group} = groupItem
            return group.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          });
      }
    },
    /**
     * массив элементов для групп аттрибутов
     * @returns {array}
     */
    catalogList() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      if (attributeActiveId === null)
        return [];
      else {
        let groupList = this.catalogListBuffer.find((groupItem) => {
          return groupItem.attributeId === attributeActiveId;
        });
        if (typeof groupList === 'undefined')
          return [];
        else
          return groupList.content;
      }
    },
    /**
     * массив несгруппированных значений аттрибутов
     * @returns {array}
     */
    ungroupedList() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      if (attributeActiveId === null)
        return [];
      else {
        let ungroupedList = this.ungroupedListBuffer.find((ungroupedItem) => {
          return ungroupedItem.attributeId === attributeActiveId;
        });
        if (typeof ungroupedList === 'undefined')
          return [];
        else
          return ungroupedList.content.filter((groupItem) => {
            const {name} = groupItem
            return name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          });
      }
    }
  },
  mounted() {
    // устанавливаем текущее название страницы
    this.setCurrentViewName("Настройки алиасов");
    // получаем право на отображение
    // console.log(this.activeProjectId);
    this.isPermission = serviceAuth.checkPermission(this.activeProjectId, 'change_settings');
    // получаем аттрибуты
    if (this.isPermission) {
      this.getAttributes();
    }
  },
  methods: {
    /**
     * проксируем мутации из стора
     * @property {Function} setCurrentViewName - установить текущее имя страницы
     */
    ...mapMutations([
      'setCurrentViewName',
      'setSearchText'
    ]),
    onSearch(value) {
      this.setSearchText(value)
    },
    /**
     * запрос на получение аттрибутов алиасов
     * @async
     */
    async getAttributes() {
      this.attributeIsPreloader = true;
      try {
        let {data = []} = await serviceApi.post(routeAliasesAttributes);
        this.attributeList = data;
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
        else if (error.response.data.data.message === 'Доступ запрещен') {
          alert('Доступ запрещен');
          this.$router.push({name: 'analyticsSummary'});
        }
      }
      this.attributeIsPreloader = false;
    },
    /**
     * запрос на получение групп аттрибута алиасов
     * @async
     */
    async getGroups() {
      this.groupIsPreloader = true;
      try {
        let {data = []} = await serviceApi.post(routeAliasesAttributeGroups, this.reqBodyGetGroups);
        let groups = {
          attributeId: this.attributeItemActive.id,
          content: [...data]
        };
        // результат запроса добавляем в буферный массив
        this.groupListBuffer.push(groups);
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.groupIsPreloader = false;
    },
    /**
     * запрос на получение несгруппированных значений аттрибутов алиасов
     * @async
     */
    async getUngrouped() {
      this.ungroupedIsPreloader = true;
      try {
        const {data = []} = await serviceApi.post(routeAliasesUngroupedValues, this.reqBodyGetUngrouped);
        const {actual = [], archive = []} = data;
        let collectData = [];
        actual.forEach((dataItem, index) => {
          let item = {
            id: index,
            name: dataItem,
            isActive: true
          };
          collectData.push(item);
        });
        archive.forEach((dataItem, index) => {
          let item = {
            id: index + actual.length,
            name: dataItem,
            isActive: false
          };
          collectData.push(item);
        })
        let ungrouped = {
          attributeId: this.attributeItemActive.id,
          content: [...collectData]
        };
        this.ungroupedListBuffer.push(ungrouped);
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.ungroupedIsPreloader = false;
    },
    /**
     * запрос на получение несгруппированных значений аттрибутов алиасов
     * @async
     */
    async getCatalog() {
      this.catalogIsPreloader = true
      try {
        let {data = []} = await serviceApi.post(routeAliasesCatalogValues, this.reqBodyGetUngrouped);
        let collectData = [];
        data.forEach((dataItem) => {
          let item = {
            id: dataItem.id,
            name: dataItem.name,
            childs: dataItem.childs
          };
          collectData.push(item);
        });
        let ungrouped = {
          attributeId: this.attributeItemActive.id,
          content: [...collectData]
        };
        this.catalogListBuffer.push(ungrouped);
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.catalogIsPreloader = false;
    },
    /**
     * запрос на добавление новой группы
     * @async
     */
    async postAddGroup() {
      this.groupIsPreloader = true;
      this.ungroupedIsPreloader = true;
      try {
        await serviceApi.post(routeAliasesAddGroup, this.reqBodyPostAddGroup);
        this.afterAddGroup();
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.groupIsPreloader = false;
      this.ungroupedIsPreloader = false;
    },
    /**
     * запрос на добавление значений в группу
     */
    async postAddGroupValues() {
      this.groupIsPreloader = true;
      this.ungroupedIsPreloader = true;
      try {
        await serviceApi.post(routeAliasesAddGroup, this.reqBodyPostAddGroupValues);
        this.afterAddGroupValues();
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.groupIsPreloader = false;
      this.ungroupedIsPreloader = false;
    },
    /**
     * запрос на удаление группы
     * @async
     */
    async postRemoveGroup() {
      this.groupIsPreloader = true;
      this.ungroupedIsPreloader = true;
      try {
        await serviceApi.post(routeAliasesRemoveGroup, this.reqBodyPostRemoveGroup);
        this.afterRemoveGroup();
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.groupIsPreloader = false;
      this.ungroupedIsPreloader = false;
    },
    /**
     *
     * @async
     */
    async postSetCatalogValues(sendingData) {
      this.catalogIsPreloader = true;
      try {
        await serviceApi.post(routeCatalogSetValue, sendingData);
        this.afterCatalogValuesSet(sendingData);
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.catalogIsPreloader = false;
    },
    /**
     *
     * @async
     */
    async postDeleteCatalogValues(sendingData) {
      this.catalogIsPreloader = true;
      try {
        await serviceApi.post(routeCatalogDeleteValue, sendingData);
        this.afterCatalogValuesDelete(sendingData);
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.catalogIsPreloader = false;
    },
    /**
     * запрос на удаление значения из группы
     * @async
     */
    async postRemoveGroupValues() {
      this.groupIsPreloader = true;
      this.ungroupedIsPreloader = true;
      try {
        await serviceApi.post(routeAliasesRemoveGroup, this.reqBodyPostRemoveGroupValues);
        this.afterRemoveGroupValues();
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.groupIsPreloader = false;
      this.ungroupedIsPreloader = false;
    },
    /**
     * запрос на создание задачи в крон
     * @async
     */
    async postCreateTask() {
      try {
        let {data = {}} = await serviceApi.post(routeAliasesCreateTask, this.reqBodyPostCreateTask);
        let {message = null} = data;
        if (message !== null)
          alert(message);
        this.afterRemoveGroupValues();
      } catch (error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
    },
    /**
     * клик по элементу списка аттрибутов
     * @param {object} catalogListItem - элемент списка аттрибутов
     */
    onClickCatalogListItem(catalogListItem) {
      this.groupItemActive = null
      if(this.catalogItemActive !== catalogListItem) {
        this.catalogItemActive = catalogListItem
      } else {
        this.catalogItemActive = null
      }
    },
    /**
     * клик по элементу списка аттрибутов
     * @param {object} attributeListItem - элемент списка аттрибутов
     */
    onClickAttributeListItem(attributeListItem) {
      this.ungroupedСheckedValues = [];
      this.groupItemActive = null;
      if (this.attributeItemActive !== null && this.attributeItemActive.id === attributeListItem.id) {
        this.attributeItemActive = null;
      } else {
        // если в буферном массиве нет значения - делаем запрос
        this.attributeItemActive = attributeListItem;
        this.attributeItemActiveId = this.attributeItemActive.id
        let isRequestGroups = this.groupListBuffer.find((groupItem) => {
          return groupItem.attributeId === attributeListItem.id;
        });
        let isRequestUngrouped = this.ungroupedListBuffer.find((ungroupedItem) => {
          return ungroupedItem.attributeId === attributeListItem.id;
        });
        if (typeof isRequestGroups == 'undefined')
          this.getGroups();
        if (typeof isRequestUngrouped == 'undefined')
          this.getUngrouped();
        // if(attributeListItem.id == 4)
        // {
        //   let isRequestCatalog = this.ungroupedListBuffer.find((ungroupedItem) => {
        //     return ungroupedItem.attributeId === attributeListItem.id;
        //   });
        //   if (typeof isRequestCatalog == 'undefined')
        //     this.getCatalog();
        // }
      }
    },
    /**
     * клик по элементу списка групп
     * @param {object} groupListItem - элемент списка групп
     */
    onClickGroupListItem(groupListItem) {
      this.catalogItemActive = null;
      if (this.groupItemActive !== null && this.groupItemActive.group === groupListItem.group) {
        this.groupItemActive = null;
      } else {
        this.groupItemActive = groupListItem;
      }
    },
    /**
     * событие изменения чекбокса в несгруппированных значениях аттрибутов
     * @param {array} checkedValues - выбранные значения
     */
    onChangeUngroupedCheckbox(checkedValues) {
      this.ungroupedСheckedValues = checkedValues;
    },
    /**
     * событие клика по иконке элемента не сгрупированных значений
     * @param {object} listItem - элемент списка
     */
    onClickUngroupedIconPrev(listItem) {
      this.groupValueNew = listItem;
      this.postAddGroupValues();
    },
    /**
     * событие клика по иконке в значениях группы
     */
    onClickGroupIconPrev(subListItem) {
      this.groupValueRemove = subListItem;
      this.postRemoveGroupValues();
    },
    /**
     * событие клика по кнопке создать алиас
     */
    onClickGroupCreate() {
      if (this.ungroupedСheckedValues.length === 0)
        alert('Выберите не привязанные значения');
      else {
        this.isModal = true;
      }
    },
    /**
     * событие клика по кнопке синхронизировать
     */
    onClickCreateTask() {
      this.postCreateTask();
    },
    /**
     * событие закрытие модального окна добавления группы
     */
    closeModal() {
      this.isModal = false;
    },
    /**
     * событие добавления имени новой группы
     * @param {string} groupNameNew - название новой группы
     */
    onSubmitGroupAdd(groupNameNew) {
      this.groupNameNew = groupNameNew;
      this.closeModal();
      this.postAddGroup();
    },
    /**
     * событие удаления группы
     * @param {string} groupName - название группы
     */
    onClickGroupRemove(groupName) {
      this.groupRemoveName = groupName;
      this.postRemoveGroup();
    },
    /**
     * событие удаления группы
     * @param {object} group - название группы
     */
    onClickAddToCatalog(group) {
      let sendingData = {
        "group":group.group,
        "catalog":this.catalogItemActive.name
      }
      this.postSetCatalogValues(sendingData);
    },
    /**
     * клик по элементу списка аттрибутов
     * @param {object} subListItem - элемент списка аттрибутов
     */
    onClickDeleteCatalog(subListItem) {
      let sendingData = {
        "group":subListItem,
        "catalog":this.catalogItemActive.name
      }
      this.postDeleteCatalogValues(sendingData);
    },
    /**
     * функция обновления группы в буферном массиве
     * @param {number} attributeActiveId - id активного атрибута
     * @param {function} callbackUpdate - колбэк
     */
    updateGroup(attributeActiveId, callbackUpdate) {
      let groupListItemIndex = this.groupListBuffer.findIndex((groupItem) => {
        return groupItem.attributeId === attributeActiveId;
      });
      let groupListItems = this.groupListBuffer.find((groupItem) => {
        return groupItem.attributeId === attributeActiveId;
      });
      if (typeof groupListItems !== 'undefined') {
        callbackUpdate(attributeActiveId, groupListItems, groupListItemIndex);
      }
    },
    /**
     * функция обновления не сгруппированных значений в буферном массиве
     * @param {number} attributeActiveId - id активного атрибута
     * @param {function} callbackUpdate - колбэк
     */
    updateUngrouped(attributeActiveId, callbackUpdate) {
      let ungroupedListItemIndex = this.ungroupedListBuffer.findIndex((ungroupedItem) => {
        return ungroupedItem.attributeId === attributeActiveId;
      });
      let ungroupedList = this.ungroupedListBuffer.find((ungroupedItem) => {
        return ungroupedItem.attributeId === attributeActiveId;
      });
      if (typeof ungroupedList !== 'undefined') {
        callbackUpdate(attributeActiveId, ungroupedList, ungroupedListItemIndex);
      }
    },
    /**
     * функция редактирования буферных массивов после добавления группы
     */
    afterAddGroup() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      if (attributeActiveId !== null) {
        this.updateGroup(attributeActiveId, (attributeActiveId, groupListItems, groupListItemIndex) => {
          let content = groupListItems.content.slice();
          content.push({
            group: this.groupNameNew,
            values: this.ungroupedСheckedValues
          });
          content.sort((val1, val2) => val1.group > val2.group ? 1 : -1);
          let groups = {
            attributeId: attributeActiveId,
            content: [...content]
          };
          this.groupListBuffer.splice(groupListItemIndex, 1, groups);
        });
        this.updateUngrouped(attributeActiveId, (attributeActiveId, ungroupedList, ungroupedListItemIndex) => {
          let content = ungroupedList.content.slice();
          this.ungroupedСheckedValues.forEach((checkedItem) => {
            let deleteItemIndex = content.findIndex((contentItem) => {
              return contentItem.name === checkedItem;
            });
            content.splice(deleteItemIndex, 1);
          });
          let ungrouped = {
            attributeId: attributeActiveId,
            content: [...content]
          };
          this.ungroupedListBuffer.splice(ungroupedListItemIndex, 1, ungrouped);
        });
        this.groupNameNew = '';
        this.ungroupedСheckedValues = [];
      }
    },
    /**
     * функция редактирования буферных массивов после добавления нового значения в группу
     */
    afterAddGroupValues() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      if (attributeActiveId !== null) {
        this.updateGroup(attributeActiveId, (attributeActiveId, groupListItems, groupListItemIndex) => {
          let content = groupListItems.content.slice();
          let activeContentItemIndex = content.findIndex((contentItem) => {
            return contentItem.group === this.groupItemActive.group
          });
          let activeContentItem = content.find((contentItem) => {
            return contentItem.group === this.groupItemActive.group
          });
          let values = activeContentItem.values.slice();
          values.push(this.groupValueNew.name);
          values.sort((val1, val2) => val1 > val2 ? 1 : -1);
          content[activeContentItemIndex] = {...content[activeContentItemIndex], values: values};
          let groups = {
            attributeId: attributeActiveId,
            content: [...content]
          };
          this.groupListBuffer.splice(groupListItemIndex, 1, groups);
        });
        this.updateUngrouped(attributeActiveId, (attributeActiveId, ungroupedList, ungroupedListItemIndex) => {
          let content = ungroupedList.content.slice();
          let deleteContentItemIndex = content.findIndex((contentItem) => {
            return contentItem.name === this.groupValueNew.name;
          });
          content.splice(deleteContentItemIndex, 1);
          let ungrouped = {
            attributeId: attributeActiveId,
            content: [...content]
          };
          this.ungroupedListBuffer.splice(ungroupedListItemIndex, 1, ungrouped);
        });
        this.groupValueNew = null;
      }
    },
    /**
     * функция редактирования буферных массивов после удаления группы
     */
    afterRemoveGroup() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      if (attributeActiveId !== null) {
        this.updateGroup(attributeActiveId, (attributeActiveId, groupListItems, groupListItemIndex) => {
          let content = groupListItems.content.slice();
          let deleteItemIndex = content.findIndex((contentItem) => {
            return contentItem.group === this.groupRemoveName;
          });
          this.groupValuesRemove = content[deleteItemIndex].values;
          content.splice(deleteItemIndex, 1);
          let groups = {
            attributeId: attributeActiveId,
            content: [...content]
          };
          this.groupListBuffer.splice(groupListItemIndex, 1, groups);
        });
        this.updateUngrouped(attributeActiveId, (attributeActiveId, ungroupedList, ungroupedListItemIndex) => {
          let content = ungroupedList.content.slice();
          this.groupValuesRemove.forEach((value, index) => {
            let item = {
              id: content.length + index,
              name: value,
              isActive: true
            };
            content.push(item);
          });
          content.sort((val1, val2) => {
            const {isActive: isActive1 = false, name: name1 = ""} = val1;
            const {isActive: isActive2 = false, name: name2 = ""} = val2;
            switch (true){
              case isActive1 === isActive2 && name1 > name2:
                return 1;
              case isActive1 === isActive2 && name1 < name2:
                return -1;
              case isActive1 > isActive2:
                return -1;
              case isActive1 < isActive2:
                return 1;
            }
          });
          let ungrouped = {
            attributeId: attributeActiveId,
            content: [...content]
          };
          this.ungroupedListBuffer.splice(ungroupedListItemIndex, 1, ungrouped);
        });
        this.groupItemActive = null;
        this.groupValuesRemove = [];
      }
    },
    /**
     * функция редактирования буферных массивов после удаления группы
     */
    afterCatalogValuesSet(sendingData) {
      this.catalogList.forEach(function(item){
        if(item.id === sendingData.catalog)
        {
          item.childs.push(sendingData.group)
        }
      })
      this.groupList.forEach(function(item){
        if(item.group === sendingData.group)
        {
          item.grouped = true
        }
      })
    },
    /**
     * функция редактирования буферных массивов после удаления группы
     */
    afterCatalogValuesDelete(sendingData) {
      this.catalogList.forEach(function(item){
        if(item.id === sendingData.catalog)
        {
          item.childs.forEach(function(child, i){
            if(child === sendingData.group)
            {
              item.childs.splice(i, 1)
            }
          })
        }
      })
      this.groupList.forEach(function(item){
        if(item.group === sendingData.group)
        {
          item.grouped = false
        }
      })
    },
    /**
     * функция редактирования буферных массивов после удаления значения из группы
     */
    afterRemoveGroupValues() {
      let attributeActiveId = this.attributeItemActive === null ? null : this.attributeItemActive.id;
      if (attributeActiveId !== null) {
        this.updateGroup(attributeActiveId, (attributeActiveId, groupListItems, groupListItemIndex) => {
          let content = groupListItems.content.slice();
          let activeContentItemIndex = content.findIndex((contentItem) => {
            return contentItem.group === this.groupItemActive.group
          });
          let activeContentItem = content.find((contentItem) => {
            return contentItem.group === this.groupItemActive.group
          });
          let values = activeContentItem.values.slice();
          let valueRemoveIndex = values.findIndex((value) => {
            return value === this.groupValueRemove;
          });
          values.splice(valueRemoveIndex, 1);
          content[activeContentItemIndex] = {...content[activeContentItemIndex], values: values};
          let groups = {
            attributeId: attributeActiveId,
            content: [...content]
          };
          this.groupListBuffer.splice(groupListItemIndex, 1, groups);
        });
        this.updateUngrouped(attributeActiveId, (attributeActiveId, ungroupedList, ungroupedListItemIndex) => {
          let content = ungroupedList.content.slice();
          let item = {
            id: content.length + 1,
            name: this.groupValueRemove,
            isActive: true
          };
          content.push(item);
          content.sort((val1, val2) => {
            const {isActive: isActive1 = false, name: name1 = ""} = val1;
            const {isActive: isActive2 = false, name: name2 = ""} = val2;
            switch (true){
              case isActive1 === isActive2 && name1 > name2:
                return 1;
              case isActive1 === isActive2 && name1 < name2:
                return -1;
              case isActive1 > isActive2:
                return -1;
              case isActive1 < isActive2:
                return 1;
            }
          });
          let ungrouped = {
            attributeId: attributeActiveId,
            content: [...content]
          };
          this.ungroupedListBuffer.splice(ungroupedListItemIndex, 1, ungrouped);
        });
        this.groupValueRemove = '';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-card {
  position: relative;
  margin: 0 10px 10px 0;
  padding: 30px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  width: 100%;
  background: #fff;
}

.view-settings-aliases {
  display: flex;
  flex-wrap: wrap;
}

.card__btn_action {
  border: none;
  background: none;
  color: #2686e6;
  cursor: pointer;
  outline: none;
}
</style>